export { default as useMainScroll } from './useMainScroll';
